import {
  GET_CUSTOM_COMP_ID,
  SET_CUSTOM_COMP_ID,
} from "../constants/custom-comp-id";

export const getCustomCompId = () => ({
  type: GET_CUSTOM_COMP_ID,
});

export const setCustomCompId = (id) => ({
  type: SET_CUSTOM_COMP_ID,
  id,
});
